export const faqCategories = [
  {
    id: "getting-started",
    title: "Getting Started",
    intro: "Basic questions families usually ask before starting counselling.",
    items: [
      {
        question: "Who should contact TheCareerSpace?",
        answer:
          "Students and parents exploring bachelor's admissions, master's admissions, MBBS in India, or MBBS abroad can contact TheCareerSpace for structured guidance."
      },
      {
        question: "How can we begin the counselling process?",
        answer:
          "You can begin by submitting an enquiry on the contact page or calling the counselling desk to schedule an initial discussion."
      },
      {
        question: "Can parents join counselling discussions?",
        answer:
          "Yes. Parent participation is encouraged, especially during shortlisting and final decision-making stages."
      },
      {
        question: "Can we begin even if we have not finalized a course yet?",
        answer:
          "Yes. Many families start while still exploring options. Early counselling helps narrow direction before shortlisting."
      }
    ]
  },
  {
    id: "service-scope",
    title: "Admissions Guidance Scope",
    intro: "Questions related to service coverage and support journey.",
    items: [
      {
        question: "Do you support both bachelor's and master's admissions in India?",
        answer:
          "Yes. TheCareerSpace supports both undergraduate and postgraduate admissions pathways in India."
      },
      {
        question: "Is guidance available for MBBS abroad as well?",
        answer:
          "Yes. We provide counselling support for families evaluating MBBS abroad options through a structured and practical approach."
      },
      {
        question: "Do you help only with shortlisting or with the full process?",
        answer:
          "Support is designed as a full guided journey from profile understanding and shortlisting to applications and final admission closure."
      },
      {
        question: "Do you support students comparing options across multiple states?",
        answer:
          "Yes. State-wise comparisons are part of counselling when families need broader college evaluation before deciding."
      }
    ]
  },
  {
    id: "counselling-style",
    title: "Counselling Style",
    intro: "How TheCareerSpace works with students and families.",
    items: [
      {
        question: "How is your counselling approach different from generic advice?",
        answer:
          "Recommendations are based on student profile, family priorities, and practical feasibility instead of one-size-fits-all suggestions."
      },
      {
        question: "Can students and parents discuss multiple pathways in one consultation?",
        answer:
          "Yes. Multi-pathway discussions are possible when families need comparative clarity before choosing a direction."
      },
      {
        question: "Will we receive clear next steps after counselling?",
        answer:
          "Yes. The process is designed to provide actionable next steps at each stage rather than abstract guidance."
      },
      {
        question: "Can counselling cover both student aspirations and parent concerns together?",
        answer:
          "Yes. Sessions are structured to keep student goals and family priorities aligned in one practical discussion."
      }
    ]
  },
  {
    id: "admissions-process",
    title: "Admissions Process Support",
    intro: "Practical questions around shortlisting, applications, and decision flow.",
    items: [
      {
        question: "How are shortlist recommendations prepared?",
        answer:
          "Recommendations are prepared using student profile, pathway goals, location preference, and practical feasibility."
      },
      {
        question: "Can we get support for application sequencing and timelines?",
        answer:
          "Yes. TheCareerSpace provides structured process guidance so key deadlines and documentation steps remain clear."
      },
      {
        question: "Do you support families deciding between MBBS India and MBBS abroad?",
        answer:
          "Yes. Comparative counselling is available for families evaluating both paths before making final commitments."
      },
      {
        question: "What is the best first step after reading this FAQ?",
        answer:
          "Book a counselling discussion through the contact page and share your current stage so the team can guide you with relevant next steps."
      }
    ]
  }
];

export const faqPreviewForHome = [
  {
    question: "Who should start with TheCareerSpace counselling?",
    answer:
      "Students and families exploring bachelor's, master's, MBBS in India, or MBBS abroad can start with a counselling discussion."
  },
  {
    question: "Do you provide guidance only for one pathway?",
    answer:
      "No. TheCareerSpace supports multiple pathways and helps families compare them when needed."
  },
  {
    question: "Can parents be part of the discussions?",
    answer:
      "Yes. Parent participation is encouraged at key stages so choices remain transparent and aligned."
  },
  {
    question: "How do we begin if we are still unsure about options?",
    answer:
      "Start with a contact form enquiry or counselling call. The process is designed to build clarity from uncertainty."
  },
  {
    question: "Will we receive clear next steps after each discussion?",
    answer:
      "Yes. Sessions are structured to leave families with practical, stage-wise action points."
  }
];

export const faqPreviewForServices = [
  {
    question: "Do you provide counselling for all four major pathways on this website?",
    answer:
      "Yes. Bachelor's in India, Master's in India, MBBS in India, and MBBS abroad are all supported through structured guidance."
  },
  {
    question: "Is family participation welcomed during service discussions?",
    answer:
      "Yes. Parent participation is encouraged so decisions remain aligned and transparent."
  },
  {
    question: "Can we approach TheCareerSpace if we are still confused between paths?",
    answer:
      "Absolutely. Many families begin when they are uncertain, and counselling is designed to build clarity step by step."
  },
  {
    question: "Can one counselling plan include guidance for multiple states?",
    answer:
      "Yes. State and college comparisons can be included when families are evaluating options across regions."
  }
];

export const faqPreviewForAdmissions = [
  {
    question: "Will counselling include both options and practical trade-offs?",
    answer:
      "Yes. Discussions are balanced around strengths, constraints, and realistic admission possibilities."
  },
  {
    question: "Can this guidance help avoid rushed final decisions?",
    answer:
      "Yes. The process structure is built to reduce last-minute pressure and improve decision confidence."
  },
  {
    question: "Do we get support till final admission closure?",
    answer:
      "Yes. The service model is designed for continuity till major admission steps are complete."
  },
  {
    question: "Can parents join the admission planning discussion from the start?",
    answer:
      "Yes. Parent involvement is welcomed from early counselling stages to improve decision alignment."
  }
];
